import { JsonValue } from 'type-fest';

import { ResourceSchemaSet } from '../entities/resources';
import { SkillDatasetKey } from '../entities/skill-dataset';
import { OptionalStatType, StatType } from '../entities/stat.type';

export interface IBasicAssetProps {
  name: string;
  // * Being used anywhere? Likely to be?
  // description?: string;
  resources: ResourceSchemaSet;
}

export interface IStructuredAnimClipConfigEntry {
  clipName: string;
  timeToMatch?: number | string;
  loop?: boolean;
  reverse?: boolean;
}
export type AnimClipConfigEntry = string | IStructuredAnimClipConfigEntry;
export type AnimClipConfigStateEntry = { [stateName: string]: AnimClipConfigEntry };
type SkillAnimClipResourceUsage = { animClips: AnimClipConfigStateEntry };

export type SkillResourceUsage = Record<string, SkillAnimClipResourceUsage & Record<string, JsonValue>>;

export interface IEntitySkillData {
  datasetKey: SkillDatasetKey;
  stateResourceUsage: SkillResourceUsage;
  deployPosOffset?: number;
  deployPosOverride?: number;
}

export type IEntityStatData = {
  [OptionalStatType.raw]?: number;
} & {
  [key in Exclude<
    StatType,
    OptionalStatType.raw |
    OptionalStatType.scaleCastRange |
    OptionalStatType.scaleDamageIntakeAll |
    OptionalStatType.scaleDamageIntakeRole |
    OptionalStatType.scaleSpeedAttack
  >
  ]: number
};

export type ConfigStatSet = { [key in StatType]?: number } | undefined;

// TODO: This will certainly need to be elaborating on, just what I could come up with very quickly and seemingly organized enough for now.
// TODO: Buildings in particular require a square base possibly with rotation, as with the "tower", the footprint of which is rotated 45 degrees.
export interface IEntityStructure {
  scale_visualResources?: number; // Only applies to visual graphics, just a hard upfront scalar for the client.
  clickBounds_radius?: number;
  clickBounds_width?: number;
  clickBounds_height?: number;
  clickBounds_offset_x?: number;
  clickBounds_offset_y?: number;
  radius_collider_nav?: number;
  width_collider_nav?: number;
  height_collider_nav?: number;
  radius_collider_targeting?: number;
  radius_collider_hurtbox?: number;
  width_collider_hurtbox?: number;
  height_collider_hurtbox?: number;
  radius_collider_hitbox?: number;
  width_collider_hitbox?: number | number[];
  height_collider_hitbox?: number | number[];
}

// Not extending IPartConfigData because the skill and stats in this case are optional.
export interface EntityConfigItem extends IBasicAssetProps {
  type?: string;
  skills?: IEntitySkillData[];
  stats?: ConfigStatSet;
  structure?: IEntityStructure;
  data?: Record<string, any>;
}

export type EntityDataset = { [entityKey: string]: EntityConfigItem };
